// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calcContainerHistory{
  min-height: calc(100vh - 330px);
}

.mainContentHistory {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 20px 20px 30px;
  background-color: white;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  gap: 40px;
  padding-bottom: 60px;
}

.titleHistory {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  border-bottom: 1px solid #77797b;
}

.titleHistory h4 {
    margin: 0px;
    font-family: 'Bosch Sans', sans-serif !important;
    padding: 20px;
}

.contentHistory{
    width: 95%;
}

.accordionTitle {
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  width: 100%;
  gap: 12px;
}

.accordionTitleWithoutDays {
  grid-template-columns: auto auto;
}

.accordionTitle span {
  white-space: nowrap;
}

.utilsDays {
  font-family: 'Bosch Sans', sans-serif;
  font-weight: bold;
}

.accordionContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 35px;
}

.accordionContent p {
  margin: 0px;
  padding: 0px;
  font-family: 'Bosch Sans', sans-serif;
}

.accordionContentRow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  width: fit-content;
}

.historyGroupChip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 2px 10px;
  border-radius: 12px;
  background-color: #e8f1ff;
  color: #003e64;
  font-family: 'Bosch Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .accordionContentRow {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/componentes/history/history.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,+CAA+C;EAC/C,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,gCAAgC;AAClC;;AAEA;IACI,WAAW;IACX,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":[".calcContainerHistory{\n  min-height: calc(100vh - 330px);\n}\n\n.mainContentHistory {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px 20px 20px 30px;\n  background-color: white;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);\n  gap: 40px;\n  padding-bottom: 60px;\n}\n\n.titleHistory {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  border-bottom: 1px solid #77797b;\n}\n\n.titleHistory h4 {\n    margin: 0px;\n    font-family: 'Bosch Sans', sans-serif !important;\n    padding: 20px;\n}\n\n.contentHistory{\n    width: 95%;\n}\n\n.accordionTitle {\n  display: grid;\n  grid-template-columns: auto auto auto;\n  align-items: center;\n  width: 100%;\n  gap: 12px;\n}\n\n.accordionTitleWithoutDays {\n  grid-template-columns: auto auto;\n}\n\n.accordionTitle span {\n  white-space: nowrap;\n}\n\n.utilsDays {\n  font-family: 'Bosch Sans', sans-serif;\n  font-weight: bold;\n}\n\n.accordionContent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-left: 35px;\n}\n\n.accordionContent p {\n  margin: 0px;\n  padding: 0px;\n  font-family: 'Bosch Sans', sans-serif;\n}\n\n.accordionContentRow {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  width: fit-content;\n}\n\n.historyGroupChip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 24px;\n  padding: 2px 10px;\n  border-radius: 12px;\n  background-color: #e8f1ff;\n  color: #003e64;\n  font-family: 'Bosch Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n@media (max-width: 600px) {\n  .accordionContentRow {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
